import Vue from 'vue';
import OwlCarousel from 'v-owl-carousel';
import Vuelidate from 'vuelidate';
import FormSemiNuevos from '../pages/semi-nuevos/FormSemiNuevos.vue';

Vue.use(Vuelidate);

Vue.component('carousel', OwlCarousel);
Vue.component('form-semi-nuevos', FormSemiNuevos);

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (document.getElementById('section-banner-semi-nuevos')) {
  new Vue({
    el: '#section-banner-semi-nuevos',
  });
}

if (document.getElementById('form-semi-nuevos')) {
  new Vue({
    el: '#form-semi-nuevos',
  });
}

const metroStations = {
  'santa-ana': {
    zone: 'Santiago Centro',
    title:
      '<span class="semi-text-orange">Metro Santa Ana L2 |</span> Centro Histórico y Distrito Cívico',
    description:
      '<strong>Calles principales:</strong> Amunátegui, San Martín, Morandé, Santo Domingo, Bandera y General Mackenna.<br><br>Ubicado en pleno corazón de Santiago, este sector destaca por su conectividad, cercanía a centros de trabajo, universidades, comercio, servicios públicos y una amplia red de transporte. Ideal para quienes buscan vivir cerca de todo y reducir tiempos de traslado.',
  },
  'parque-almagro': {
    zone: 'Santiago Centro',
    title:
      '<span class="semi-text-orange">Metro Parque Almagro L3 |</span> Barrio Tradicional del Centro',
    description:
      '<strong>Calles principales:</strong> Eleuterio Ramírez, Eyzaguirre, Nataniel Cox, San Ignacio y Toesca.<br><br>Uno de los sectores con mayor crecimiento residencial del centro de Santiago. Destaca por sus amplias áreas verdes, cercanía a universidades, servicios y excelente conectividad hacia distintos puntos de la ciudad.',
  },
  'san-alberto-hurtado': {
    zone: 'Estación Central',
    title: '<span class="semi-text-orange">Metro San Alberto Hurtado L1 |</span> Estación Central',
    description:
      '<strong>Calles principales:</strong> Alameda, Toro Mazotte, Ecuador, Las Rejas y General Velásquez.<br><br>Una alternativa atractiva para quienes buscan buena conectividad y acceso a servicios. El sector cuenta con múltiples opciones de transporte, comercio y cercanía a importantes polos laborales.',
  },
  hospitales: {
    zone: 'Independencia',
    title:
      '<span class="semi-text-orange">Metro Hospitales / Plaza Chacabuco L3 |</span> Independencia',
    description:
      '<strong>Calles principales:</strong> Independencia, Profesor Zañartu, Santos Dumont, La Paz y Domingo Santa María.<br><br>Un barrio con fuerte desarrollo residencial y excelente acceso a servicios de salud, comercio y conectividad. Su cercanía al centro de Santiago lo convierte en una excelente opción para primera vivienda.',
  },
  'santa-lucia': {
    zone: 'Santiago Centro',
    title:
      '<span class="semi-text-orange">Metro Santa Lucía L1 |</span> Barrio Tradicional del Centro',
    description:
      '<strong>Calles principales:</strong> San Diego, Santa Isabel, Lord Cochrane, Eleuterio Ramírez y San Ignacio.<br><br>Un sector residencial consolidado, con excelente acceso a comercio de barrio, servicios, centros educacionales y áreas culturales. Combina la vida urbana con la comodidad de tener todo a pocos minutos caminando.',
  },
};

const infoMetro = document.getElementById('info-metro');
const metroPins = document.querySelectorAll('.pin-mapa');
const metroInfoAnimationDuration = 250;
let selectedStation = 'santa-lucia';
let metroInfoAnimation = null;

if (infoMetro && metroPins.length) {
  const zone = infoMetro.querySelector('.info-metro-zone');
  const title = infoMetro.querySelector('.info-metro-title');
  const description = infoMetro.querySelector('.info-metro-description');

  const setPinHover = (pin, isHovered) => {
    const currentPin = isHovered ? 'pin-1.svg' : 'pin-2.svg';
    const nextPin = isHovered ? 'pin-2.svg' : 'pin-1.svg';

    pin.src = pin.src.replace(currentPin, nextPin);
  };

  const setSelectedPin = (stationKey) => {
    selectedStation = stationKey;

    metroPins.forEach((pin) => {
      setPinHover(pin, pin.dataset.station === selectedStation);
    });
  };

  const renderMetroInfo = (station) => {
    zone.textContent = station.zone;
    title.innerHTML = station.title;
    description.innerHTML = station.description;
  };

  const updateMetroInfo = (stationKey, shouldAnimate = true) => {
    const station = metroStations[stationKey];

    if (
      !station ||
      !zone ||
      !title ||
      !description ||
      (shouldAnimate && stationKey === selectedStation)
    ) {
      return;
    }

    setSelectedPin(stationKey);

    if (!shouldAnimate) {
      renderMetroInfo(station);
      return;
    }

    window.clearTimeout(metroInfoAnimation);
    infoMetro.classList.remove('is-entering');
    infoMetro.classList.add('is-leaving');

    metroInfoAnimation = window.setTimeout(() => {
      renderMetroInfo(station);
      infoMetro.classList.remove('is-leaving');
      infoMetro.classList.add('is-entering');

      window.requestAnimationFrame(() => {
        infoMetro.classList.remove('is-entering');
      });
    }, metroInfoAnimationDuration);
  };

  metroPins.forEach((pin) => {
    pin.addEventListener('mouseenter', () => setPinHover(pin, true));
    pin.addEventListener('mouseleave', () => {
      setPinHover(pin, pin.dataset.station === selectedStation);
    });
    pin.addEventListener('click', () => updateMetroInfo(pin.dataset.station));
    pin.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      updateMetroInfo(pin.dataset.station);
    });
  });

  updateMetroInfo(selectedStation, false);
}
